<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 头部选择项 -->
    <div class="headerSelect bg-white pdt-10 pdb-20 pdl-10">
      <div class="flex">
        <div
          v-for="(v, i) in headerSelect"
          :key="i"
          :class="
            currentHeaderSelect === v ? 'timeSelect-active' : 'timeSelect'
          "
          @click="changeTime(v)"
        >
          {{ v }}
        </div>
        <el-button>查询</el-button>
      </div>
    </div>

    <!-- 收益数目 -->
    <div class="color052154 mgt-20">
      <!-- 收益 -->
      <div class="earnings flex pdl-20 f16 aic">
        <div class="month-earnings f20">本月收益（元）9999.99</div>
        <div class="mgr-30">总收益：¥####</div>
        <div class="mgr-30">已提现收益：¥####</div>
        <div>可提现收益：¥####</div>
      </div>
      <!-- 提现 -->
      <div class="withdraw-deposit-btn flex mgt-30">
        <div @click="dialogFormVisible = true">提现</div>
        <div @click="recordTableVisible = true">提现记录</div>
      </div>

      <!-- 提现弹框 -->
      <el-dialog
        title="发起提现"
        :visible.sync="dialogFormVisible"
        width="40%"
        center
        :close-on-click-modal="modalFase"
      >
        <div class="center color052154 f12 mgb-30">
          可提现收益：¥###.##（待结算收益：¥###.##）
        </div>
        <el-form :model="withdrawdepositform" :label-position="labelPosition">
          <el-form-item label="发起提现金额：">
            <el-input
              v-model="withdrawdepositform.name"
              autocomplete="off"
              placeholder="请输入提现金额（如1.5）"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="提现方式：">
            <el-select
              v-model="withdrawdepositform.region"
              placeholder="请选择提现方式"
            >
              <el-option label="银行卡" value="shanghai"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款方户名：">
            <el-input
              v-model="withdrawdepositform.name"
              autocomplete="off"
              placeholder="请输入收款方户名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="收款方账户：">
            <el-input
              v-model="withdrawdepositform.name"
              autocomplete="off"
              placeholder="请输入银行卡号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="开户行：">
            <el-input
              v-model="withdrawdepositform.name"
              autocomplete="off"
              placeholder="请输入银行名称（##银行）"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="mgr-50" @click="clickcancelwithdrawdeposit"
            >取 消</el-button
          >
          <el-button type="primary" @click="clickwithdrawdeposit"
            >发 起</el-button
          >
        </div>
      </el-dialog>

      <!-- 发起提现操作确认弹框 -->
      <el-dialog
        title="操作确认"
        :visible.sync="affirmFormVisible"
        center
        :close-on-click-modal="modalFase"
      >
        <div class="f16 mgb-20 color052154 center">
          请确认本次发起提现金额为###元
        </div>
        <el-form
          hide-required-asterisk
          :model="affirmform"
          :label-position="labelPosition"
        >
          <el-form-item label="收款方户名：">
            <el-input v-model="affirmform.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="收款方账户：">
            <el-input v-model="affirmform.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="开户行：">
            <el-input v-model="affirmform.name" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="mgr-50" @click="affirmFormVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="affirmFormVisible = false"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 提现记录弹框 -->
      <el-dialog
        :close-on-click-modal="modalFase"
        title="提现记录"
        :visible.sync="recordTableVisible"
        center
      >
        <el-table :data="gridData" stripe border>
          <el-table-column
            type="index"
            :index="indexMethod"
            label="序号"
            width="100"
            fixed="left"
          >
          </el-table-column>
          <el-table-column
            property="date"
            label="提现编号"
            width="150"
          ></el-table-column>
          <el-table-column
            property="date"
            label="发起人"
            width="100"
          ></el-table-column>
          <el-table-column
            property="name"
            label="提现发起时间"
            width="150"
          ></el-table-column>
          <el-table-column
            property="name"
            label="发起体现金额（元）"
            width="100"
          ></el-table-column>
          <el-table-column
            property="name"
            label="打款状态"
            width="100"
          ></el-table-column>
          <el-table-column
            property="name"
            label="实际打款金额（元）"
            width="100"
          ></el-table-column>
          <el-table-column
            property="name"
            label="打款时间"
            width="150"
          ></el-table-column>
          <el-table-column fixed="right" label="打款凭证" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="lookVoucher(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            property="name"
            label="打款备注"
            width="200"
            fixed="right"
          ></el-table-column>
        </el-table>
      </el-dialog>

      <!-- 打款凭证弹框 -->
      <el-dialog
        :close-on-click-modal="modalFase"
        title="打款凭证"
        center
        :visible.sync="voucherdialogVisible"
        width="30%"
      >
        <div class="voucherImg">
          <img v-if="voucherImgSrc" :src="voucherImgSrc" /><i
            v-else
            class="el-icon-picture-outline"
            >暂无凭证</i
          >
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="voucherdialogVisible = false"
            >已 知 晓</el-button
          >
        </span>
      </el-dialog>
    </div>

    <!-- 收益列表 -->
    <div class="earningsLists mgt-30">
      <div class="f16 fw-600">收益列表</div>
      <!-- 表格 -->
      <el-table
        stripe
        :data="tableData"
        border
        style="width: 100%"
        height="300"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="100"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="date" label="时间" width="250">
        </el-table-column>
        <el-table-column prop="equipmentNum" label="设备数" width="250">
        </el-table-column
        ><el-table-column prop="shareBenefitNum" label="分润订单数" width="250">
        </el-table-column
        ><el-table-column prop="shareBenefitEarnings" label="分润收益">
        </el-table-column>
        <el-table-column fixed="right" width="100" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="godetails"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      modalFase: false,
      labelPosition: "top",
      headerSelect: ["本月", "上月", "更多"], //头部选择项
      currentHeaderSelect: "本月", //头部选择激活项，默认
      tableData: [
        {
          date: "2016-05-02",
          equipmentNum: "50",
          shareBenefitNum: "999",
          shareBenefitEarnings: "999.99",
        },
      ], //收益列表数据
      withdrawdepositform: {}, //提现弹框数据
      dialogFormVisible: false, //是否打开提现框
      affirmform: {}, //提现操作确认弹框数据
      affirmFormVisible: false, //是否打开提现操作确认框
      recordTableVisible: false, //是否打开提现记录弹框
      gridData: [{ name: "嘻嘻" }], //提现记录数据
      voucherdialogVisible: false, //是否打开打款凭证弹框
      voucherImgSrc: "", //打款凭证图片
    };
  },
  methods: {
    // 改变头部时间选择相对应得数据
    changeTime(item) {
      this.currentHeaderSelect = item;
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 表格查看详情按钮，进入详情页面
    godetails() {
      this.$router.push("/agentmanagement/agent_earnings/details_day");
    },
    // 发起提现弹框发起按钮点击事件
    clickwithdrawdeposit() {
      // this.dialogFormVisible = false;
      this.affirmFormVisible = true;
    },
    // 发起提现弹框取消按钮点击事件
    clickcancelwithdrawdeposit() {
      this.$confirm("是否取消提现？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.dialogFormVisible = false;
        this.$message({
          type: "info",
          message: "已取消本次提现",
        });
      });
    },
    // 提现记录查看打款凭证按钮
    lookVoucher(row) {
      console.log(row);
      this.voucherdialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
// 头部选择项
.headerSelect {
  .timeSelect {
    padding: 5px 30px;
    border: 1px solid var(--input-border);
    margin-right: 30px;
    cursor: pointer;
  }
  .timeSelect-active {
    padding: 5px 30px;
    border: 1px solid var(--accent);
    background-color: var(--accent);
    margin-right: 30px;
    color: #fff;
    cursor: pointer;
  }
}
// 收益数
.earnings {
  .month-earnings {
    background: var(--card-bg);
    border-radius: 15px;
    padding: 30px 20px;
    margin-right: 30px;
  }
}
// 提现与提现记录按钮
.withdraw-deposit-btn {
  div {
    border: 1px solid var(--accent);
    background: var(--card-bg);
    margin-right: 30px;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
  }
}
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}

// 提现弹框表单
.el-dialog {
  .el-form {
    margin-left: 50%;
    transform: translateX(-50%);
    .el-input,
    .el-select {
      width: 80%;
    }
  }
}
// 凭证图片
.voucherImg {
  width: 100%;
  height: 200px;
  background-color: #ccc;
  position: relative;
  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 50px;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
